/**
 * Errors that mean a queued mutation can never succeed as written — drop it from the offline
 * queue rather than retry forever. Shared between apps/app's and apps/painter-view's Apollo
 * clients so adding a new ignorable error only needs to happen in one place.
 */
export const ignoredOfflineErrors = [
  'Failed to fetch',
  'Save Rejected:',
  'Response not successful:',
  'Rev Mismatch',
  'document without _rev'
]
